import { CacheProvider } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Switch,
  TableCell,
  TableRow,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useContext, useEffect, useState } from "react";
import AddButton from "../../components/300/AddButton";
import BasicTable from "../../components/300/BasicTable";
import OfficeContext from "../../context/OfficeContext";
import useAuth from "../../hooks/useAuth";
import EditIcon from "@mui/icons-material/Edit";

import createCache from "@emotion/cache";
import { NavLink, useNavigate } from "react-router-dom";
import PositionContext from "../../context/PositionContext";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
const muiCache = createCache({
  key: "mui",
  prepend: true,
});
function Office() {
  const api = useAxiosPrivate();
  let navigate = useNavigate();
  const { user } = useAuth();
  const officeContext = useContext(OfficeContext);
  const positionContext = useContext(PositionContext);
  const [modalState, setModalState] = useState({
    open: false,
    name: null,
    courseCode: null,
    disabled: null,
  });
  const [added, setAdded] = useState({ status: false });

  const handleClose = () => {
    setModalState({ ...modalState, open: false });
  };
  const handleOpen = (id) => {
    let office = officeContext.officeState.filter((p) => {
      return p.id === id;
    })[0];
    console.log(office);
    setModalState({
      name: office.name,
      id: office.id,
      open: true,
      disabled: !Number(office.status),
    });
  };
  const handleDisable = () => {
    //debugger;
    console.log(modalState);
    api
      .patch("/office/disableOffice", { id: modalState.id })
      .then((response) => {
        alert(JSON.stringify(response, null, 2));
        setAdded({ status: Boolean(response.data.status) });
      })
      .catch((err) => {
        alert(JSON.stringify(err.response.data, null, 2));
      });

    handleClose();
  };

  useEffect(() => {
    api
      .get("office/offices")
      .then((res) => {
        officeContext.officeDispatch({
          type: "loadOffice",
          offices: res.data.offices,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [added]);

  const columnHead = [
    //{
    //  label: "ID",
    //  name: "id",
    //  options: {
    //    filter: false,
    //    sort: false,
    //  },
    //},
    {
      label: "Name",
      name: "name",
      options: {
        filter: true,
      },
    },
    {
      label: "Type",
      name: "type",
      options: {
        filter: true,
      },
    },
    {
      label: "Status",
      name: "statusAlias",
      options: {
        filter: true,
        sort: false,
        display: "none",
      },
    },
    {
      label: "Position",
      name: "position_id",
      options: {
        filter: true,
      },
    },
    {
      label: "Action",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{ width: "100px", display: "flex", alignItems: "center" }}
            >
              {user.roles.includes(304) && (
                <EditIcon
                  color="primary"
                  onClick={() => {
                    navigate("editOffice", {
                      state: { id: value },
                    });
                  }}
                />
              )}
              {/*<NavLink to={`/deleteCourse/${value}`}>*/}
              {user.roles.includes(305) && (
                <Switch
                  checked={Number(
                    tableMeta.tableData.filter((row, index) => {
                      console.log(row);
                      if (row.id == value) {
                        return true;
                      }
                      return false;
                    })[0].status
                  )}
                  onClick={() => {
                    handleOpen(value);
                  }}
                />
              )}

              {/*</NavLink>*/}
            </div>
          );
        },
      },
      name: "delete",
    },
  ];
  const options = {
    selectableRows: "none",
  };

  let offices = officeContext.officeState.map((office) => {
    return {
      ...office,
      position_id: office?.Position?.title,
      delete: office.id,
      statusAlias: Number(office.status) == 1 ? "Active" : "InActive",
    };
  });
  const StyledMUIDataTable = styled(MUIDataTable)(({ theme }) => ({
    background: theme.palette.background.default,
  }));

  return (
    <>
      <CacheProvider value={muiCache}>
        <StyledMUIDataTable
          title={""}
          data={offices}
          columns={columnHead}
          options={options}
        />
      </CacheProvider>

      <Dialog open={modalState.open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">
          {modalState.disabled ? "Enable " : "Disable "}
          {modalState.name} ?
        </DialogTitle>
        <DialogContent>
          {modalState.disabled
            ? "Now you will be able to assign courses"
            : "once you disable it you won't be able to assign courses"}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ color: "teritiary.darker" }}>
            cancel
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleDisable}>
            {modalState.disabled ? "Enable" : "Disable"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Office;
